import { ValidationContextStateValue } from 'modules/experiments/types';
import { createContext, useContext } from 'react';
import noop from 'utils/noop';

export const initialValidationContextState: ValidationContextStateValue = {
  deleteTemplateErrorsForAllVariantLocales: noop,
  updateTemplateErrorsForAllVariantLocales: noop,
  currentLocalesTemplateError: [],
  localesWithError: [],
  experimentHasErrors: false,
};

export const ValidationContext = createContext(initialValidationContextState);

export const useVariantTemplateValidationContext = () => useContext(ValidationContext);
